// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.
import {LOCATION_CHANGE} from 'react-router-redux'

import {
  SHOW_EDIT_FORM,
  SHOW_ADD_FORM,
  CHECK_ITEMS,
  CHANGE_CHECK_ALL_BOX
} from '../actions/table'


const initialState = {
  editing: 0,
  adding: false,
  checkAll: false,
  keepChecked: false,
  checkedItems: {}
}

let payload = {}
let checkedItems
let formName

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_EDIT_FORM:
      payload = {
        editing: action.payload,
        adding: false
      }

      return {...state, ...payload}
    case SHOW_ADD_FORM:
      payload = {
        adding: !state.adding,
        editing: 0
      }
      return {...state, ...payload}
    case CHECK_ITEMS:
      checkedItems = state.checkedItems
      formName = action.payload.formName
      checkedItems[formName] != null ? checkedItems[formName] = null : checkedItems[formName] = action.payload.item
      return {...state, checkedItems: checkedItems}
    case CHANGE_CHECK_ALL_BOX:
      return {...state, ...action.payload}
    case LOCATION_CHANGE:
      return initialState
    default:
      return state
  }
}
